export type SiteSearchKind =
  | "page"
  | "service"
  | "article"
  | "tool"
  | "support";

export type SiteSearchDocument = {
  id: string;
  kind: SiteSearchKind;
  title: string;
  description: string;
  href: string;
  keywords?: string[];
  meta?: string;
};

export type SiteSearchHit = {
  document: SiteSearchDocument;
  score: number;
  titleMatches: ReadonlyArray<readonly [number, number]>;
};

export function mergeTitleRanges(
  ranges: ReadonlyArray<readonly [number, number]>,
): Array<[number, number]> {
  const sorted = ranges
    .map(([start, end]) => [start, end] as [number, number])
    .filter(([start, end]) => start >= 0 && end >= start)
    .sort((a, b) => a[0] - b[0]);

  const merged: Array<[number, number]> = [];
  for (const range of sorted) {
    const previous = merged.at(-1);
    if (!previous || range[0] > previous[1] + 1) {
      merged.push(range);
      continue;
    }
    previous[1] = Math.max(previous[1], range[1]);
  }
  return merged;
}
